import { render } from "./FooterOG1.vue?vue&type=template&id=52c1ffa6&scoped=true"
import script from "./FooterOG1.vue?vue&type=script&lang=js"
export * from "./FooterOG1.vue?vue&type=script&lang=js"

import "./FooterOG1.vue?vue&type=style&index=0&id=52c1ffa6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52c1ffa6"]])

export default __exports__